import { request } from './http';

export async function getConstructionPermittingSites() {
    // Add timestamp to force fresh request and bypass cache
    const timestamp = new Date().getTime();
    return request(`/construction-permitting-sites?t=${timestamp}`);
  }

export async function getConstructionPermittingSite(id) {
    return request(`/construction-permitting-sites/${id}`);
  }

export async function createConstructionPermittingSite(siteData) {
    return request('/construction-permitting-sites', {
      method: 'POST',
      body: JSON.stringify(siteData)
    });
  }

export async function updateConstructionPermittingSite(id, siteData) {
    return request(`/construction-permitting-sites/${id}`, {
      method: 'PUT',
      body: JSON.stringify(siteData)
    });
  }

export async function deleteConstructionPermittingSite(id) {
    return request(`/construction-permitting-sites/${id}`, {
      method: 'DELETE'
    });
  }

export async function getProjects() {
    // Add timestamp to force fresh request and bypass cache
    const timestamp = new Date().getTime();
    return request(`/projects?t=${timestamp}`);
  }

export async function getProject(id) {
    return request(`/projects/${id}`);
  }

export async function createProject(projectData) {
    return request('/projects', {
      method: 'POST',
      body: JSON.stringify(projectData)
    });
  }

export async function updateProject(id, projectData) {
    return request(`/projects/${id}`, {
      method: 'PUT',
      body: JSON.stringify(projectData)
    });
  }

export async function updateProjectMapFile(id, fileData) {
    return request(`/projects/${id}/map-file`, {
      method: 'PUT',
      body: JSON.stringify(fileData)
    });
  }

export async function deleteProject(id) {
    return request(`/projects/${id}`, {
      method: 'DELETE'
    });
  }

export async function recycleProject(id) {
    return request(`/projects/${id}/recycle`, {
      method: 'POST'
    });
  }

export async function restoreProject(id) {
    return request(`/projects/${id}/restore`, {
      method: 'POST'
    });
  }

export async function getProjectPermits(projectId) {
    return request(`/projects/${projectId}/permits`);
  }

export async function getProjectPermitTasks(projectId) {
    return request(`/projects/${projectId}/permit-tasks`);
  }

export async function getProjectActionLogs(projectId) {
    return request(`/projects/${projectId}/action-logs`);
  }

export async function getProjectFiles(projectId) {
    return request(`/projects/${projectId}/files`);
  }

export async function getAllProjectFiles() {
    return request('/project-files');
  }

export async function createProjectFile(fileData) {
    return request('/project-files', {
      method: 'POST',
      body: JSON.stringify(fileData),
    });
  }

export async function deleteProjectFile(id) {
    return request(`/project-files/${id}`, {
      method: 'DELETE',
    });
  }

export async function getProjectStatusReports(projectId) {
    return request(`/projects/${projectId}/status-reports`);
  }

export async function getComplianceRecordOptions(companyId) {
    return request(`/companies/${companyId}/compliance-record-options`);
  }

export async function createPermit(permitData) {
    return request('/permits', {
      method: 'POST',
      body: JSON.stringify(permitData)
    });
  }

export async function updatePermit(id, permitData) {
    return request(`/permits/${id}`, {
      method: 'PUT',
      body: JSON.stringify(permitData)
    });
  }

export async function deletePermit(id) {
    return request(`/permits/${id}`, {
      method: 'DELETE'
    });
  }

export async function saveProjectSchedule(projectId, changes) {
    return request(`/projects/${projectId}/schedule`, {
      method: 'POST',
      body: JSON.stringify(changes),
    });
  }

export async function createPermitTask(taskData) {
    return request('/permit-tasks', {
      method: 'POST',
      body: JSON.stringify(taskData)
    });
  }

export async function updatePermitTask(id, taskData) {
    return request(`/permit-tasks/${id}`, {
      method: 'PUT',
      body: JSON.stringify(taskData)
    });
  }

export async function deletePermitTask(id) {
    return request(`/permit-tasks/${id}`, {
      method: 'DELETE'
    });
  }

export async function getProjectGanttDependencies(projectId) {
    return request(`/projects/${projectId}/gantt-dependencies`);
  }

export async function createGanttDependency(dependencyData) {
    return request('/gantt-dependencies', {
      method: 'POST',
      body: JSON.stringify(dependencyData)
    });
  }

export async function updateGanttDependency(id, dependencyData) {
    return request(`/gantt-dependencies/${id}`, {
      method: 'PUT',
      body: JSON.stringify(dependencyData)
    });
  }

export async function deleteGanttDependency(id) {
    return request(`/gantt-dependencies/${id}`, {
      method: 'DELETE'
    });
  }

export async function createActionLog(actionLogData) {
    return request('/action-logs', {
      method: 'POST',
      body: JSON.stringify(actionLogData)
    });
  }

export async function updateActionLog(id, actionLogData) {
    return request(`/action-logs/${id}`, {
      method: 'PUT',
      body: JSON.stringify(actionLogData)
    });
  }

export async function deleteActionLog(id) {
    return request(`/action-logs/${id}`, {
      method: 'DELETE'
    });
  }

export async function createStatusReport(statusReportData) {
    return request('/status-reports', {
      method: 'POST',
      body: JSON.stringify(statusReportData)
    });
  }

export async function updateStatusReport(id, statusReportData) {
    return request(`/status-reports/${id}`, {
      method: 'PUT',
      body: JSON.stringify(statusReportData)
    });
  }

export async function deleteStatusReport(id) {
    return request(`/status-reports/${id}`, {
      method: 'DELETE'
    });
  }

export async function getSchedulerStatus() {
    return request('/scheduler/status');
  }

export async function startScheduler() {
    return request('/scheduler/start', {
      method: 'POST'
    });
  }

export async function stopScheduler() {
    return request('/scheduler/stop', {
      method: 'POST'
    });
  }

export async function startSchedulerJob(jobName) {
    return request(`/scheduler/jobs/${jobName}/start`, {
      method: 'POST'
    });
  }

export async function stopSchedulerJob(jobName) {
    return request(`/scheduler/jobs/${jobName}/stop`, {
      method: 'POST'
    });
  }

export async function triggerSchedulerJob(jobName) {
    return request(`/scheduler/jobs/${jobName}/trigger`, {
      method: 'POST'
    });
  }

export async function getSchedulerJobHistory(filters = {}) {
    const params = new URLSearchParams();
    if (filters.jobName) params.append('jobName', filters.jobName);
    if (filters.limit) params.append('limit', filters.limit);
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);
    if (filters.status) params.append('status', filters.status);
    const queryString = params.toString();
    return request(`/scheduler/jobs/history${queryString ? `?${queryString}` : ''}`);
  }

export async function getSchedulerMetrics(filters = {}) {
    const params = new URLSearchParams();
    if (filters.days) params.append('days', filters.days);
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);
    const queryString = params.toString();
    return request(`/scheduler/metrics${queryString ? `?${queryString}` : ''}`);
  }

export async function retrySchedulerJob(executionId) {
    return request(`/scheduler/jobs/${executionId}/retry`, {
      method: 'POST'
    });
  }

export async function generateComplianceRecords() {
    return request('/scheduler/generate-compliance-records', {
      method: 'POST'
    });
  }

export async function getComplianceRecordsDueToday() {
    return request('/scheduler/compliance-records-due-today');
  }

export async function getEnvironmentalSamplingDueToday() {
    return request('/scheduler/environmental-sampling-due-today');
  }

export const constructionPermittingApi = {
  getConstructionPermittingSites,
  getConstructionPermittingSite,
  createConstructionPermittingSite,
  updateConstructionPermittingSite,
  deleteConstructionPermittingSite,
  getProjects,
  getProject,
  createProject,
  updateProject,
  updateProjectMapFile,
  deleteProject,
  recycleProject,
  restoreProject,
  getProjectPermits,
  getProjectPermitTasks,
  getProjectActionLogs,
  getProjectFiles,
  getAllProjectFiles,
  createProjectFile,
  deleteProjectFile,
  getProjectStatusReports,
  getComplianceRecordOptions,
  createPermit,
  updatePermit,
  deletePermit,
  saveProjectSchedule,
  createPermitTask,
  updatePermitTask,
  deletePermitTask,
  getProjectGanttDependencies,
  createGanttDependency,
  updateGanttDependency,
  deleteGanttDependency,
  createActionLog,
  updateActionLog,
  deleteActionLog,
  createStatusReport,
  updateStatusReport,
  deleteStatusReport,
  getSchedulerStatus,
  startScheduler,
  stopScheduler,
  startSchedulerJob,
  stopSchedulerJob,
  triggerSchedulerJob,
  getSchedulerJobHistory,
  getSchedulerMetrics,
  retrySchedulerJob,
  generateComplianceRecords,
  getComplianceRecordsDueToday,
  getEnvironmentalSamplingDueToday,
};

